import UserAccount from "./UserAccount.mjs";
import { query, showElement, hideElement, updateAlert } from "../utils.mjs";
import WindCreekClient from "./WindCreekClient.mjs";
import { profileAnimation } from "./my-rewards-animations.mjs";

UserAccount.windCreekClient = new WindCreekClient();

let loginTypes = UserAccount.getLoginTypes();

let profilePage = query("[data-profile-page]");

// This function populates the profile data on the page
function setupProfilePage(accountData, profileData) {
  if (UserAccount.isMiamiSite()) {
    const profileInfo = [
      [
        {
          label: "Name",
          value:
            profileData.patronInfo.firstName +
            " " +
            profileData.patronInfo.lastName,
        },
        {
          label: "Join Date",
          value: profileData.patronInfo.rewardsJoinDate
            .replace(/^0/, "")
            .replace(/\/0/, "/"),
        },
        {
          label: "Birthday",
          value: profileData.patronInfo.birthDate
            .replace(/^0/, "")
            .replace(/\/0/, "/"),
        },
      ],
      [
        {
          label: "Rewards Number",
          value: profileData.patronAccountNumber,
        },
      ],
      [
        {
          label: "Primary Address",
          value: buildAddress(profileData.patronInfo),
        },
      ],
      [
        {
          label: "Email",
          value: profileData.patronInfo.email,
        },
      ],
      [
        {
          label: "Mobile Phone",
          value: formatPhoneNumber(profileData.patronInfo.mobilePhone),
        },
        {
          label: "Home Phone",
          value: formatPhoneNumber(profileData.patronInfo.homePhone),
        },
      ],
    ];

    if (profileData.patronInfo.accountCard) {
      profileInfo[1].push({
        label: `${profileData.patronInfo.accountCard.cardType} Card Number`,
        value: profileData.patronInfo.accountCard.cardNumber,
      });
    }

    if (profileData.patronInfo.addressOther.length > 0) {
      profileData.addressOther.forEach((address) => {
        profileInfo[2].push({
          label: `${address.addressType} Address`,
          value: buildAddress(address),
        });
      });
    }

    if (profileData.patronInfo.emailOther.length > 0) {
      profileData.emailOther.forEach((email, i) => {
        profileInfo[3].push({
          label: `${email.emailType} Email ${i + 1}`,
          value: email.email,
        });
      });
    }

    if (profileData.patronInfo.phoneOther.length > 0) {
      profileData.phoneOther.forEach((phone, i) => {
        profileInfo[4].push({
          label: `${phone.phoneType} Phone ${i + 1}`,
          value: formatPhoneNumber(phone),
        });
      });
    }

    const profileInfoContainer = profilePage.querySelector(
      "[data-profile-info]"
    );
    profileInfo.forEach((group) => {
      const groupContainer = document.createElement("div");
      groupContainer.classList.add('profile-group', 'bg-light', 'rounded', 'p-3', 'p-md-4');
      let groupHTML = `<div class="row gy-4">`;
      group.forEach((info) => {
        if (info.value) {
          groupHTML += `
          <div class="col-md-6 col-lg-4">
            <div class="profile-info">
              <span class="d-block label-2 mb-1 text-secondary">${info.label}</span>
              <div class="d-block subhead-3">${info.value}</div>
            </div>
          </div>
        `;
        }
      });
      profileInfoContainer.appendChild(groupContainer);
      groupContainer.innerHTML = groupHTML;
    });

    //Add the text after the profile info
    const textContainer = document.createElement("div");
    const profileText = `<p class='profile-info mb-0 mt-3'>To make changes to this information, visit <span class='text-uppercase'>Guest Services</span> in person at any Wind Creek Casino.</p>`;
    profileInfoContainer.appendChild(textContainer);
    textContainer.innerHTML = profileText;

    profileAnimation();
  } else {
    profilePage.querySelector("[data-email]").textContent =
      profileData.patronInfo.email;

    profilePage.querySelector("[data-birthday]").textContent =
      profileData.patronInfo.birthDate.replace(/^0/, "").replace(/\/0/, "/");

    profilePage.querySelector("[data-address]").innerHTML = buildAddress(
      profileData.patronInfo
    );

    if (
      profileData.patronInfo?.mobilePhone &&
      profileData.patronInfo.mobilePhone !== "not found"
    ) {
      profilePage.querySelector(
        "[data-profile-mobile-phone-value]"
      ).textContent = profileData.patronInfo.mobilePhone;
      showElement("[data-profile-mobile-phone]");
    }

    if (
      profileData.patronInfo?.homePhone &&
      profileData.patronInfo.homePhone !== "not found"
    ) {
      profilePage.querySelector("[data-profile-home-phone-value]").textContent =
        profileData.patronInfo.homePhone;
      showElement("[data-profile-home-phone]");
    }

    const joinDates = profilePage.querySelectorAll("[data-join-date]");
    joinDates.forEach((joinDate, i) => {
      joinDate.textContent = profileData.patronInfo.rewardsJoinDate
        .replace(/^0/, "")
        .replace(/\/0/, "/");
    });

  }

  // Populate the fields in the profile update form with the existing values
  accountData.email = accountData?.email || '';
  accountData.displayName = accountData?.displayName || '';
  accountData.preferredLocation = accountData?.preferredLocation || '';

  profilePage.querySelector('[name="email"]').value = accountData.email;
  profilePage
    .querySelector('[name="email"]')
    .setAttribute("data-original-value", accountData.email);
  profilePage.querySelector('[name="display-name"]').value =
    accountData.displayName;
  profilePage
    .querySelector('[name="display-name"]')
    .setAttribute("data-original-value", accountData.displayName);
  profilePage.querySelector('[name="preferred-location"]').value =
    accountData.preferredLocation;
  profilePage
    .querySelector('[name="preferred-location"]')
    .setAttribute("data-original-value", accountData.preferredLocation);
}

// Checks to see if a field in the API response exists and has a useful, non-empty value in it
function fieldExists(fieldName, object) {
  return (
    object[fieldName] &&
    object[fieldName] !== "not found" &&
    object[fieldName] !== "not specified"
  );
}

// Generates the formatted address HTML for display using the address data from the API
function buildAddress(patronInfo) {
  let address = "";

  let cityFound = false;
  let stateProvinceFound = false;

  if (fieldExists("address1", patronInfo)) {
    address += patronInfo.address1;
  }

  if (fieldExists("address2", patronInfo)) {
    address += "<br>" + patronInfo.address2;
  }

  if (fieldExists("city", patronInfo)) {
    address += "<br>" + patronInfo.city;
    cityFound = true;
  }

  if (fieldExists("stateProvince", patronInfo)) {
    if (cityFound) {
      address += ", ";
    } else {
      address += "<br>";
    }

    address += patronInfo.stateProvince;

    stateProvinceFound = true;
  }

  if (fieldExists("postalCode", patronInfo)) {
    if (cityFound || stateProvinceFound) {
      address += " ";
    } else {
      address += "<br>";
    }

    address += patronInfo.postalCode;
  }

  return address;
}

// Formats a phone number string into a standard format
function formatPhoneNumber(phoneNumberString) {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

function buildPreferenceOptions(options, currentPreferences) {
  const div = document.getElementById("preferences");
  const divPriority = document.getElementById("priority");
  const currentPriority = currentPreferences.priorityCategoryCode;

  if (div) {
    options.forEach(option => {
      const currentPreference = currentPreferences.preferences.find(p => p.categoryCode === option.code);

      switch (option.code) {
        case 'AMENITY_SCENT':
          buildScentPreferenceOptions(div, option, currentPreference);
          break;
        case 'ELEVATOR_PROXIMITY':
        case 'FLOOR_HEIGHT':
          buildSelectPreferenceOptions(div, option, currentPreference);
          break;
        case 'HYPOALLERGENIC_BEDDING':
          // buildTogglePreferenceField(div, option, currentPreference);
          break;
        default:
          console.error('Unaccounted for preference code: ', option.code, ' in buildPreferenceOptions() in profile.js. Please add a case for this code in the switch statement.');
      }
    });
  }

  if (divPriority) {
    // This would dynamically build the options, but it's better hard-coded as there is no "no preference" option, and an extra unaccoutned for option of "Hypoallergenic Bedding."
    // options.forEach(option => {
    //   const wrapper = document.createElement('div');
    //   wrapper.className = 'form-check my-2';
    //
    //   const input = document.createElement('input');
    //   input.className = 'form-check-input';
    //   input.type = 'radio';
    //   input.name = 'priority';
    //   input.id = option.code;
    //
    //   const label = document.createElement('label');
    //   label.className = 'form-check-label fw-normal';
    //   label.htmlFor = option.code;
    //   label.textContent = option.name;
    //
    //   wrapper.append(input, label);
    //   divPriority.appendChild(wrapper);
    // });

    const priorityOptions = divPriority.querySelectorAll("input[name='priority']");
    priorityOptions.forEach(option => {
      if (currentPriority) {
        option.checked = option.value === currentPriority;
      } else {
        option.checked = option.value === 'NO_PREFERENCE';
      }
    });
  }
}

function buildPreferenceLabelContainer(name, forAttr, isToggleField = false) {
  const label = document.createElement('label');
  label.setAttribute('for', forAttr);
  label.className = 'label-2 mb-2';
  label.textContent = name;

  const container = document.createElement('div');
  container.className = 'mb-4';
  if (isToggleField) {
    container.className = 'form-check';
  }

  return [label, container];
}

function createCheckIcon() {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.classList.add('active-icon');
  svg.setAttribute('height', '17px');
  svg.setAttribute('width', '17px');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'rgb(163, 43, 41)');

  const hiddenPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  hiddenPath.setAttribute('d', 'M0 0h24v24H0V0z');
  hiddenPath.setAttribute('fill', 'none');

  const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  checkPath.setAttribute(
    'd',
    'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'
  );

  svg.append(hiddenPath, checkPath);

  return svg;
}

function buildScentPreferenceOptions(div, preference, currentPreference) {
  const id = preference.code;

  const [label, container] = buildPreferenceLabelContainer(preference.name, id);
  div.append(label);
  div.append(container);

  const selectDesc = document.createElement('div');
  selectDesc.className = 'select-desc';
  container.append(selectDesc);

  const selected = document.createElement('div');
  selected.className = 'form-select selected';
  selected.tabIndex = 0;
  selected.setAttribute('role', 'button');
  selected.setAttribute('aria-haspopup', 'listbox');
  selected.setAttribute('aria-expanded', 'false');
  selected.setAttribute('aria-controls', 'amenity-scent-options');
  selected.textContent = 'No Preference';
  selectDesc.append(selected);

  const optionsContainer = document.createElement('div');
  optionsContainer.className = 'options-container';
  optionsContainer.id = 'amenity-scent-options';
  optionsContainer.setAttribute('role', 'listbox');
  optionsContainer.setAttribute('aria-label', 'Amenity scent options');
  optionsContainer.tabIndex = 1;
  selectDesc.append(optionsContainer);

  preference.options.forEach((item, index) => {
    const option = document.createElement('div');
    option.className = 'option';
    option.setAttribute('role', 'option');
    option.tabIndex = index === 0 ? 2 : 3;

    const input = document.createElement('input');
    input.type = 'radio';
    input.className = 'radio';
    input.id = item.code;
    input.name = id;

    const label = document.createElement('label');
    label.htmlFor = item.code;

    const title = document.createElement('span');
    title.className = 'option-title';
    title.append(document.createTextNode(item.name), createCheckIcon());

    label.appendChild(title);

    if (item.description) {
      const description = document.createElement('span');
      description.className = 'option-description';
      description.textContent = item.description;
      label.appendChild(description);
    }

    option.append(input, label);
    optionsContainer.appendChild(option);
  });

  if (selectDesc) {
    const optionsList = optionsContainer.querySelectorAll(".option");
    const current = currentPreference?.optionCode;
    let checkedOption = selectDesc.querySelector("input[name=" + id + "]:checked");

    if (current) {
      checkedOption = selectDesc.querySelector("input[name=" + id + "][id='" + current + "']");

    } else {
      checkedOption = selectDesc.querySelector("input[name=" + id + "][id='NO_PREFERENCE']");
    }

    const currentOptionTitle = checkedOption.nextElementSibling;
    checkedOption.checked = true;
    currentOptionTitle.querySelector(".active-icon").style.display = "block";
    selected.innerHTML = currentOptionTitle.querySelector(".option-title").innerHTML;

    selected.addEventListener("keydown", (event) => {
      switch (event.key) {
        case "Enter":
        case "ArrowDown":
          event.preventDefault();
          optionsContainer.classList.add("active");

          const firstOption = optionsList[0];
          firstOption?.focus();
          break;

        case "Escape":
          optionsContainer.classList.remove("active");
          selected.setAttribute("aria-expanded", "false");
          break;

        default:
          break;
      }
    });

    selectDesc.addEventListener("click", (event) => {
      event.stopPropagation();
      optionsContainer.classList.toggle("active");
      if (selectDesc.classList.contains("active")) {
        selected.setAttribute("aria-expanded", "true");
      } else {
        selected.setAttribute("aria-expanded", "false");
      }
    });

    document.addEventListener("click", (event) => {
      if (
        optionsContainer.classList.contains("active") &&
        !selectDesc.contains(event.target)
      ) {
        optionsContainer.classList.remove("active");
      }
    });

    optionsList.forEach(option => {
      const title = option.querySelector(".option-title");
      const input = option.querySelector("input");

      option.addEventListener("click", (event) => {
        event.stopPropagation();
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        selected.innerHTML = title.innerHTML;
        optionsList.forEach(o => {
          o.querySelector(".option-title").querySelector(".active-icon").style.display = "none";
        });
        title.querySelector(".active-icon").style.display = "block";
        checkedOption = selectDesc.querySelector("input[name=" + id + "]:checked");
        optionsContainer.classList.remove("active");
      });

      option.addEventListener("keydown", (event) => {
        const options = Array.from(optionsList);
        const currentIndex = options.indexOf(event.currentTarget);

        switch (event.key) {
          case "ArrowDown": {
            event.preventDefault();

            const nextOption = options[currentIndex + 1] || options[0];
            nextOption.focus();
            break;
          }
          case "ArrowUp": {
            event.preventDefault();

            const previousOption = options[currentIndex - 1] || options[options.length - 1];
            previousOption.focus();
            break;
          }
          case "Enter":
            event.preventDefault();
            event.currentTarget.click();
            break;
          case "Tab":
          case "Escape":
            optionsContainer.classList.remove("active");
            selected.setAttribute("aria-expanded", "false");
            selected.focus();
            break;

          default:
            break;
        }
      });
    });
  }
}

function buildSelectPreferenceOptions(div, preference, currentPreference) {
  const current = currentPreference?.optionCode;
  const id = preference.code;

  const [label, container] = buildPreferenceLabelContainer(preference.name, id);
  div.append(label);
  div.append(container);

  const select = document.createElement('select');
  select.className = 'form-select';
  select.setAttribute('aria-label', preference.name);
  select.id = id;
  select.name = id;

  preference.options.forEach(({ code, name }) => {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = name;

    select.appendChild(option);
  });

  container.appendChild(select);

  if (current) {
    const currentOption = select.querySelector("option[value='" + current + "']");
    currentOption.selected = true;
  } else {
    const defaultOption = select.querySelector("option[value='NO_PREFERENCE']");
    defaultOption.selected = true;
  }
}

function buildTogglePreferenceField(div, preference, currentPreference) {
  const current = currentPreference?.optionCode;
  const id = preference.code;

  const [label, container] = buildPreferenceLabelContainer(preference.name, id, true);
  div.append(label);
  div.append(container);

  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.className = 'form-check-input';
  checkbox.setAttribute('aria-label', preference.name);
  checkbox.id = id;
  checkbox.name = id;
  checkbox.value = 'ENABLED';

  container.appendChild(checkbox);

  const description = document.createElement('label');
  description.textContent = preference.description;
  description.className = 'form-check-label';
  description.htmlFor = id;
  description.for = id;

  container.appendChild(description);

  if (current === 'ENABLED') {
    checkbox.checked = true;
  }
}

function handlePreferencesSubmit(messageContainer, messageTemplate) {
  const noP = 'NO_PREFERENCE';
  const scent = document.querySelector("input[name='AMENITY_SCENT']:checked").id ?? noP;
  const elevator = document.querySelector("select#ELEVATOR_PROXIMITY").value ?? noP;
  const floor = document.querySelector("select#FLOOR_HEIGHT").value ?? noP;
  const bedding = document.querySelector("input[name='HYPOALLERGENIC_BEDDING']");
  const priority = document.querySelector("input[name='priority']:checked").value ?? noP;
  const newPreferences = {
    preferences: [
      { categoryCode: "AMENITY_SCENT", optionCode: scent },
      { categoryCode: "ELEVATOR_PROXIMITY", optionCode: elevator },
      { categoryCode: "FLOOR_HEIGHT", optionCode: floor }
    ],
    priorityCategoryCode: priority === noP ? null : priority,
  };
  // if (bedding && bedding.checked) {
  //   newPreferences.preferences.push({ categoryCode: "HYPOALLERGENIC_BEDDING", optionCode: "ENABLED" });
  // }
  let messageText = "";
  let messageStyle = "";
  let message = messageTemplate.content.cloneNode(true);
  let alertElement = message.querySelector(".alert-area");

  UserAccount.saveUserHotelStayPreferences(newPreferences)
  .then((preferencesSaveResult) => {
    // console.log('preferencesSaveResult', preferencesSaveResult);
    messageStyle = "success";
    messageText = "Hotel Stay Preferences successfully updated.";
    updateAlert(alertElement, messageText, messageStyle);
    messageContainer.appendChild(message);
  })
  .catch((error) => {
    messageStyle = "danger";
    messageText = "Sorry, we couldn't update your Hotel Stay Preferences.";
    updateAlert(
      alertElement,
      messageText,
      messageStyle,
    );
    messageContainer.appendChild(message);
    console.error('Error saving preferences:', error);
  });
}

if (profilePage) {
  if (UserAccount.isLoggedIn()) {
    // The user has an existing session. Call the API to retrieve the correct account and profile data based on the login type.
    let loginType = UserAccount.getLoginType();
    if (loginType === loginTypes.EMAIL_PASSWORD) {
      /*
      Getting all the necessary data requires multiple API calls, so we need to wait for everything to finish
      (i.e. wait for all the promises to resolve)
      */
      Promise.all([UserAccount.getAccountData(), UserAccount.getProfile()])
        .then(([accountData, profileData]) => {
          setupProfilePage(accountData, profileData);
          profilePage.classList.remove("loading-animation");
        })
        .catch((error) => {
          showElement("[data-page-error-message]");
          hideElement("[data-hide-on-page-error]");
          profilePage.classList.remove("loading-animation");
          console.log("unable to load account or profile data");
          console.error(error);
          newrelic.noticeError(error);
        });
    } else {
      UserAccount.getProfile()
        .then((profileData) => {
          let accountData = {}; // Logging in with rewards number + PIN doesn't grant access to the online account data, so set this to an empty object
          setupProfilePage(accountData, profileData);
          profilePage.classList.remove("loading-animation");
        })
        .catch((error) => {
          showElement("[data-page-error-message]");
          hideElement("[data-hide-on-page-error]");
          profilePage.classList.remove("loading-animation");
          console.log("unable to load profile data");
          console.error(error);
          newrelic.noticeError(error);
        });
    }

    // If the user logged in with an email and password, then they can use the form to update their online casino account info
    if (loginType === loginTypes.EMAIL_PASSWORD) {
      const profileForm = profilePage.querySelector("[data-profile-form]");
      if (profileForm) {
        let preferencesChangedFlag = false;
        profileForm.addEventListener("change", (event) => {
          const target = event.target;

          profileForm
            .querySelector('[type="submit"]')
            .removeAttribute("disabled");

          if (
            target.matches('input[type="radio"][name="priority"]') ||
            target.matches('input[type="radio"][name="AMENITY_SCENT"]') ||
            target.matches('select[name="ELEVATOR_PROXIMITY"]') ||
            target.matches('select[name="FLOOR_HEIGHT"]') //||
            // target.matches('input[type="checkbox"][name="HYPOALLERGENIC_BEDDING"]')
          ) {
            preferencesChangedFlag = true;
          }
        });

        // Handle the form submit event for the profile update form
        profileForm.addEventListener("submit", (event) => {
          event.preventDefault();

          let fields = {
            email: {
              updateFunction: UserAccount.setEmail.bind(UserAccount),
              errorMessage: "Sorry, we couldn't update your email address.",
            },
            "display-name": {
              updateFunction: UserAccount.setDisplayName.bind(UserAccount),
              errorMessage: "Sorry, we couldn't update your display name.",
            },
            "preferred-location": {
              updateFunction:
                UserAccount.setPreferredLocation.bind(UserAccount),
              errorMessage:
                "Sorry, we couldn't update your preferred location.",
            },
          };

          let formData = new FormData(event.target);

          // This form needs to support multiple messages (one for each API call that happens for each updated field)
          // We're using a <template> tag in the HTML as our alert template
          let messageContainer = profilePage.querySelector(
            "[data-update-result-message-container]"
          );
          messageContainer.innerHTML = "";
          let messageTemplate = profilePage.querySelector(
            "#profile-update-message-template"
          );

          for (let fieldKey in fields) {
            let newValue = formData.get(fieldKey);
            let oldValue = profileForm
              .querySelector(`[name="${fieldKey}"]`)
              .getAttribute("data-original-value");

            // Only do the API call if the value actually changed
            if (newValue !== oldValue) {
              fields[fieldKey]
                .updateFunction(newValue)
                .then((result) => {
                  let messageText = "";
                  let messageStyle = "";

                  if (
                    fieldKey === "preferred-location" &&
                    result?.preferredLocation === newValue
                  ) {
                    // The response structure of the setPreferredLocation call is a little different from the others
                    messageStyle = "success";
                    messageText = `Preferred location successfully changed to ${newValue}.`;
                    profileForm
                      .querySelector(`[name="${fieldKey}"]`)
                      .setAttribute("data-original-value", newValue);
                  } else if (result?.success === true) {
                    messageStyle = "success";
                    messageText = result?.message;
                    profileForm
                      .querySelector(`[name="${fieldKey}"]`)
                      .setAttribute("data-original-value", newValue);
                  } else {
                    messageStyle = "danger";
                    messageText =
                      result?.message ?? fields[fieldKey].errorMessage;
                    console.error(`unable to update ${fieldKey}`, result);
                  }

                  let message = messageTemplate.content.cloneNode(true);
                  let alertElement = message.querySelector(".alert-area");
                  updateAlert(alertElement, messageText, messageStyle);
                  messageContainer.appendChild(message);
                })
                .catch((error) => {
                  let message = messageTemplate.content.cloneNode(true);
                  let alertElement = message.querySelector(".alert-area");
                  updateAlert(
                    alertElement,
                    fields[fieldKey].errorMessage,
                    "danger"
                  );
                  messageContainer.appendChild(message);
                  console.log(`unable to update ${fieldKey}`);
                  console.error(error);
                  newrelic.noticeError(error);
                });
            }
          }

          // Hotel Preference Submit
          if (preferencesChangedFlag) {
            handlePreferencesSubmit(messageContainer, messageTemplate);
          }
        });
      }

      Promise.all([UserAccount.getHotelStayPreferenceCategories(), UserAccount.getUserHotelStayPreferences()])
        .then(([preferenceCategories, currentPreferences]) => {
          let displayCategories = preferenceCategories
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .filter(category => category.enabled);

          buildPreferenceOptions(displayCategories, currentPreferences);
        })
        .catch((error) => {
          // TODO: more error handling for this section
          //showElement("[data-page-error-message]");
          //hideElement("[data-hide-on-page-error]");
          //profilePage.classList.remove("loading-animation");
          console.log("unable to load hotel stay preference categories or the user's current preferences");
          console.error(error);
          newrelic.noticeError(error);
          });
    } else {
      // The user logged in with their rewards number + PIN, so hide the form
      hideElement("[data-profile-form]");
      showElement("[data-profile-form-disabled-message]");
    }
  } else {
    // User is not logged in. Redirect to home page and prompt for authentication.
    UserAccount.forceAuthentication();
  }
}
